import updateSize from './updateSize';
import updateSlides from './updateSlides';
import updateAutoHeight from './updateAutoHeight';
import updateSlidesOffset from './updateSlidesOffset';
import updateSlidesProgress from './updateSlidesProgress';
import updateProgress from './updateProgress';
import updateSlidesClasses from './updateSlidesClasses';
import updateActiveIndex from './updateActiveIndex';
import updateClickedSlide from './updateClickedSlide';

export default {
  updateSize,
  updateSlides,
  updateAutoHeight,
  updateSlidesOffset,
  updateSlidesProgress,
  updateProgress,
  updateSlidesClasses,
  updateActiveIndex,
  updateClickedSlide,
};
